import React from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { EmbedConfig } from "../../domain/EmbedConfig";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((_) => ({
  pbiReport: {
    height: "800px",
    top: 0,
    left: 0,
    position: "relative"
  },
}));

const ReportViewer: React.FC<{ embed: EmbedConfig }> = ({ embed }) => {
  const classes = useStyles();

  return (
    <div id="report-container" data-test="report-container">
      <PowerBIEmbed
        embedConfig={{
          type: "report",
          id: embed.reportId,
          embedUrl: embed.embedUrl,
          accessToken: embed.embedToken.token,
          tokenType: models.TokenType.Embed,
          settings: {
            filterPaneEnabled: false,
            navContentPaneEnabled: true,
          },
          permissions: models.Permissions.Read,
          viewMode: models.ViewMode.View
        }}
        cssClassName={classes.pbiReport}
      />
    </div>
  );
};

export { ReportViewer };